import { pluralize } from '@art-suite/art-core-ts';
import { css } from '@emotion/react';
import { ReactNode, useEffect } from 'react';

import { LAYOUT2, TYPOGRAPHY2 } from '@/Client/Styles';
import { Button } from '@/Client/Widgets';

const RECORD_LIST_HEADING_STYLE = css`
  label: RECORD_LIST_HEADING_STYLE;
  ${TYPOGRAPHY2.largeBold}
  color: var(--text1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: ${LAYOUT2.spacing1}px;
`;

const BUTTONS_STYLE = css`
  display: flex;
  gap: ${LAYOUT2.spacing1}px;
`;

type RecordListHeadingProps = {
  recordType: string;
  activeCount: number;
  archivedCount: number;
  showArchived: boolean;
  displayingAllArchiveStatuses?: boolean;
  displayCountOverride?: number;
  onToggleArchived: () => void;
  onCreate?: () => void;
  actionNodes?: ReactNode[];
};

export const RecordListHeading = ({
  recordType,
  activeCount,
  archivedCount,
  showArchived,
  displayingAllArchiveStatuses,
  displayCountOverride,
  onToggleArchived,
  onCreate,
  actionNodes,
}: RecordListHeadingProps) => {
  useEffect(() => {
    if (displayingAllArchiveStatuses) return;
    const haveArchived = archivedCount > 0;
    const haveActive = activeCount > 0;
    if ((!haveArchived && showArchived) || (!showArchived && !haveActive && haveArchived)) {
      onToggleArchived();
    }
  }, [activeCount, archivedCount, showArchived, onToggleArchived, displayingAllArchiveStatuses]);
  const titleCount = displayCountOverride ?? (showArchived ? archivedCount : activeCount);
  return (
    <div css={RECORD_LIST_HEADING_STYLE}>
      {pluralize(displayingAllArchiveStatuses ? recordType : showArchived ? 'Archived ' + recordType : recordType, titleCount)}
      <div css={BUTTONS_STYLE}>
        {actionNodes}
        {!displayingAllArchiveStatuses && archivedCount > 0 && activeCount > 0 && (
          <Button
            color={showArchived ? 'gray' : 'bluePrimary'}
            onClick={onToggleArchived}
          >
            {showArchived
              ? `Show Active ${pluralize(recordType, activeCount)}`
              : `Show Archived ${pluralize(recordType, archivedCount)}`}
          </Button>
        )}
        {onCreate && (
          <Button color='bluePrimary' onClick={onCreate}>
            New {recordType}
          </Button>
        )}
      </div>
    </div>
  );
};
